import type { StepSlug } from '@fiverr-private/store_builder_types';

const stepsToSaveStoreData: StepSlug[] = ['choose-niche', 'choose-banners', 'choose-selling-plan'] as const;

export const shouldSaveStoreData = (currentPath: StepSlug) => stepsToSaveStoreData.includes(currentPath);
